import { FeatureType, ICAMSKey, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { ContactListConfig, ICAMSContact } from '../Shared/Contacts/ContactsModels';
import { Photos } from '../Shared/Photos/Photos';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';
import { TableInLineEdits } from '../Shared/Utility/TableInLineEdits';

export enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',
    placeholder_for_legalmodals2= '#placeholder-for-legalmodals2',

    legalEventsEditModal = '#legalEventsEditModal',

    legalEventsEditApplicant = '#legalEventsEditApplicant',
    legalEventsEditApplicantTable ='#legalEventsEditApplicantTable',
    legalEventsEditApplicantAddBtn = '#legalEventsEditApplicantAddBtn',
    legalEventsEditApplicantEditBtn = '#legalEventsEditApplicantEditBtn',
    legalEventsEditApplicantDeleteBtn = '#legalEventsEditApplicantDeleteBtn',

    legalEventsEdit_ApplicantAddModal = '#legalEventsEdit_ApplicantAddModal',
    legalEventsEdit_ApplicantAddCloseBtn = '#legalEventsEdit_ApplicantAddCloseBtn',
    legalEventsEdit_ApplicantAddForm = '#legalEventsEdit_ApplicantAddForm',
    legalEventsEdit_ApplicantAdd_assignToField ='#legalEventsEdit_ApplicantAdd_assignToField',
    legalEventsEdit_ApplicantAddForm_assignToBtn = '#legalEventsEdit_ApplicantAddForm_assignToBtn',
    legalEventsEdit_ApplicantAddCancelBtn = '#legalEventsEdit_ApplicantAddCancelBtn',
    legalEventsEdit_ApplicantAddSubmitBtn = '#legalEventsEdit_ApplicantAddSubmitBtn',
    legalEventsEdit_ApplicantAddAffiliationSelect = "#legalEventsEdit_ApplicantAddAffiliationSelect",

    legalEventsEdit_ApplicantEditModal = '#legalEventsEdit_ApplicantEditModal',
    legalEventsEdit_ApplicantEditCloseBtn = '#legalEventsEdit_ApplicantEditCloseBtn',
    legalEventsEdit_ApplicantEditForm = '#legalEventsEdit_ApplicantEditForm',
    legalEventsEdit_ApplicantEdit_assignToField ='#legalEventsEdit_ApplicantEdit_assignToField',
    legalEventsEdit_ApplicantEditForm_assignToBtn = '#legalEventsEdit_ApplicantEditForm_assignToBtn',
    legalEventsEdit_ApplicantEditCancelBtn = '#legalEventsEdit_ApplicantEditCancelBtn',
    legalEventsEdit_ApplicantEditSubmitBtn = '#legalEventsEdit_ApplicantEditSubmitBtn',
    legalEventsEdit_ApplicantEditAffiliationSelect = "#legalEventsEdit_ApplicantEditAffiliationSelect"
}

declare let moment: any; // Date helper from moment()

export class LegalEvents_Applicants {
    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private photos: Photos = new Photos();
    private legalPublishToRegisterInlineEdits: Array<{ LegalCode: String, ContactRef: String, Affiliation: String, PublishToRegister: String }> = [];

    // List of buttions in the action toolbar
    private actionBtns = {
        new: { btn: null, enable: false },
        edit: { btn: null, enable: false },
        delete: { btn: null, enable: false },
    };


    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {

    }

    public initEvents = (data: ICAMSKey): void => {
        const self = this;

        // Initialize btns
        self.actionBtns = {
            new: { btn: $(jqc.legalEventsEditApplicantAddBtn +' button'), enable: false },
            edit: { btn: $(jqc.legalEventsEditApplicantEditBtn +' button'), enable: false },
            delete: { btn: $(jqc.legalEventsEditApplicantDeleteBtn +' button'), enable: false },
        };

        self.actionBtns.new.btn.on('click', function () { self.openAddApplicantModal(data.code); });
        self.actionBtns.edit.btn.on('click', function () {
            var table: any = Utilities.GetControl(jqc.legalEventsEditApplicantTable)
            let rows: Array<any> = table.bootstrapTable('getSelections');
            self.openEditApplicantModal(data.code, rows[0].ContactRef);
        });
        self.actionBtns.delete.btn.on('click', function () {
            ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
                if (r.yes == true) {
                    doDelete();
                }
                else {
                }
            }).catch(e => { });

            function doDelete() {
                var table: any = Utilities.GetControl(jqc.legalEventsEditApplicantTable)
                let rows: Array<any> = table.bootstrapTable('getSelections');
                self.DeleteApplicant(data.code, rows[0].ContactRef);
            }
        });

        // Inituialize table
        var table: any = Utilities.GetControl(jqc.legalEventsEditApplicantTable)
        table.bootstrapTable();

        table.on('check.bs.table', function (e, rowsAfter, rowsBefore) {
            self.checkVisibleButtons();
        });
        table.on('uncheck.bs.table', function (e, row, $element) {
            self.checkVisibleButtons();
        });
        table.on('click-cell.bs.table', function (e, field, value, row, $element) {
            if (field == "ContactRefListName") {
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
                var contactRef = row.ContactRef;

                events.bus.publish(events.eventOpenContactsEditPanel([{ code: contactRef, featureType: FeatureType.Contact }, false, function (listName) {
                    Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                }]));
            }
            else if (field == "PublishToRegister") {
                TableInLineEdits.setTableEdit_CheckBox($element).then(r => {
                    if (r.success == true) {
                        // Add the results to an object for submission later on
                        var ent = self.legalPublishToRegisterInlineEdits.find(f => f.LegalCode == row.LegalCode && f.ContactRef == row.ContactRef && f.Affiliation == row.Affiliation);
                        if (ent != null) ent.PublishToRegister = r.value;
                        else self.legalPublishToRegisterInlineEdits.push({ LegalCode: data.code, ContactRef: row.ContactRef, Affiliation: row.Affiliation, PublishToRegister: r.value });
                    }
                }).catch();
            }
        });

        // Reset the inline edit object
        self.legalPublishToRegisterInlineEdits = [];

        // Get data
        self.GetLegalApplicantData(data.code);
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openAddApplicantModal = (legalCode: string): void => {
        const self = this;

        Utilities.BlockUI(Utilities.GetControl(jqc.legalEventsEditModal));
        Utilities.GetControl(jqc.placeholder_for_legalmodals).load(window.G_SITEFOLDERNAME + '/Legal/LegalEventsEdit_ApplicantAddView', { legalCode: legalCode }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI(Utilities.GetControl(jqc.legalEventsEditModal));

            Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
            Utilities.GetModal(jqc.legalEventsEdit_ApplicantAddModal, ModalAction.Create);
            
            Utilities.GetControl(jqc.legalEventsEdit_ApplicantAddForm_assignToBtn).on('click', function () {
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = true;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));
                Utilities.GetModal(jqc.legalEventsEdit_ApplicantAddModal, ModalAction.Hide);

                function callback(contact: Array<ICAMSContact>) {
                    $(jqc.legalEventsEdit_ApplicantAdd_assignToField).val(contact[0].ListName);
                    $(jqc.legalEventsEdit_ApplicantAddForm + ' [name="ContactRef"]').val(contact[0].ContactRef);
                    Utilities.GetModal(jqc.legalEventsEdit_ApplicantAddModal, ModalAction.Show);

                    self.GetAffiliationList(contact[0].ContactRef);
                }
            });

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.legalEventsEdit_ApplicantAddModal));

            Utilities.GetControl(jqc.legalEventsEdit_ApplicantAddSubmitBtn).on('click', function (evt) {
                // Validate
                let form: any = Utilities.GetControl(jqc.legalEventsEdit_ApplicantAddForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($(jqc.legalEventsEdit_ApplicantAddModal + " .modal-content"));
                let formData = new FormData(<any>Utilities.GetControl(jqc.legalEventsEdit_ApplicantAddForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: window.G_SITEFOLDERNAME + '/Legal/CreateApplicant',
                    data: formData,
                    success: function (result: IAPIResult) {
                        Utilities.UnBlockUI($(jqc.legalEventsEdit_ApplicantAddModal + " .modal-content"));
                        try {
                            if (result.success == true) {
                                toastr.info('Added applicant!')
                                Utilities.GetModal(jqc.legalEventsEdit_ApplicantAddModal, ModalAction.Hide);
                                self.GetLegalApplicantData(legalCode);
                                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                            }
                            else {
                                if (result.message != null) toastr.error(result.message)
                                else toastr.error('Failed to add applicant!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }, error: function () {
                        Utilities.UnBlockUI($(jqc.legalEventsEdit_ApplicantAddModal + " .modal-content"));
                        toastr.error('Error adding applicant!');
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });


            Utilities.GetControl(jqc.legalEventsEdit_ApplicantAddCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_ApplicantAddModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
            });

            Utilities.GetControl(jqc.legalEventsEdit_ApplicantAddCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_ApplicantAddModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
            });
        });
    }

    public openEditApplicantModal = (legalCode: string, contactRef: string): void => {
        const self = this;

        var currentScrollPosition = Utilities.GetControl(jqc.legalEventsEditModal).scrollTop();
        Utilities.BlockUI(Utilities.GetControl(jqc.legalEventsEditModal));
        Utilities.GetControl(jqc.placeholder_for_legalmodals).load(window.G_SITEFOLDERNAME + '/Legal/LegalEventsEdit_ApplicantEditView', { legalCode: legalCode, contactRef: contactRef }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI(Utilities.GetControl(jqc.legalEventsEditModal));

            Utilities.GetModal(jqc.legalEventsEdit_ApplicantEditModal, ModalAction.Create);

            Utilities.GetControl(jqc.legalEventsEdit_ApplicantEditForm_assignToBtn).on('click', function () {
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = true;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));

                function callback(contact: Array<ICAMSContact>) {
                    $(jqc.legalEventsEdit_ApplicantEdit_assignToField).val(contact[0].ListName);
                    $(jqc.legalEventsEdit_ApplicantEditForm + ' [name="ContactRef"]').val(contact[0].ContactRef);

                    self.GetAffiliationList(contact[0].ContactRef);
                }
            });

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.legalEventsEdit_ApplicantEditModal));

            Utilities.GetControl(jqc.legalEventsEdit_ApplicantEditSubmitBtn).on('click', function (evt) {
                // Validate
                let form: any = Utilities.GetControl(jqc.legalEventsEdit_ApplicantEditForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($(jqc.legalEventsEdit_ApplicantEditModal + " .modal-content"));
                let formData = new FormData(<any>Utilities.GetControl(jqc.legalEventsEdit_ApplicantEditForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Legal/UpdateApplicant',
                    data: formData,
                    success: function (result: IAPIResult) {
                        Utilities.UnBlockUI($(jqc.legalEventsEdit_ApplicantEditModal + " .modal-content"));
                        try {
                            if (result.success == true) {
                                toastr.info('Updated applicant!')

                                Utilities.GetModal(jqc.legalEventsEdit_ApplicantEditModal, ModalAction.Hide);
                                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                                self.GetLegalApplicantData(legalCode);
                                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                            }
                            else {
                                if (result.message != null) toastr.error(result.message)
                                else toastr.error('Failed to edit applicant!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            
            Utilities.GetControl(jqc.legalEventsEdit_ApplicantEditCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_ApplicantEditModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.legalEventsEdit_ApplicantEditCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_ApplicantEditModal, ModalAction.Hide);
            });
        });
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetLegalApplicantData = (legalCode: string): void => {
        const self = this;

        let url = window.G_SITEFOLDERNAME + "/Legal/GetApplicantsByLegalcode";
        let query = { legalCode: legalCode };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data: Array<any> = JSON.parse(result.data);

                        var table: any = Utilities.GetControl(jqc.legalEventsEditApplicantTable)
                        table.bootstrapTable('load', data)
                        self.checkVisibleButtons();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetAffiliationList = (contactRef: string): void => {
        const self = this;

        let url = window.G_SITEFOLDERNAME + "/LUT/GetContactTypesByContactRefLUT";
        let query = { contactRef: contactRef };

        $.post(url, query,
            function (result) {
                try {
                    var el = Utilities.GetControl(jqc.legalEventsEdit_ApplicantAddAffiliationSelect);
                    el.find('option').remove().end();
                    el.append($("<option selected>"));
                    result.forEach(d => {
                        el.append($('<option>', {
                            value: d.value,
                            text: d.text
                        }));
                    });

                    //el.prop("disabled", false)
                }
                catch (err) {
                    console.log(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // UPDATES
    public UpdateLegalApplicantData = (): void => {
        const self = this;

        // Only update if there have been inline edits
        if (self.legalPublishToRegisterInlineEdits.length == 0) return;

        let url = "/Legal/UpdateLegalApplicants";
        let query = { data: self.legalPublishToRegisterInlineEdits };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success != true) {
                        toastr.info('Failed to update legal route data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // ACTION BTNS
    private checkVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.legalEventsEditApplicantTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => {
            self.actionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        self.actionBtns.new.enable = true;
        if (rows && rows.length == 1) {
            self.actionBtns.edit.enable = true;
            self.actionBtns.delete.enable = true;
        }
        else if (rows && rows.length > 1) {

        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // DELETE FROM SERVER
    private DeleteApplicant = (legalCode: string, contactRef: string): void => {
        const self = this;

        let url = window.G_SITEFOLDERNAME + "/Legal/DeleteApplicant";
        let query = { legalCode: legalCode, contactRef: contactRef };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        self.GetLegalApplicantData(legalCode);
                    }
                    else {
                        toastr.error(result.error)
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }
}




